import { createAsyncThunk } from "@reduxjs/toolkit";
import { cancelOrder, fetchOrders, submitPickupRequest } from "./ordersApi";

//Async thunk
export const fetchOrdersThunk = createAsyncThunk(
    "orders/fetchOrders",
    async (payload, { rejectWithValue, signal }) => {
        try {
            const res = await fetchOrders(payload, signal);
            return res;
        } catch (error) {
            return rejectWithValue(error.message || "Failed to fetch orders");
        }
    }
);

export const cancelOrderThunk = createAsyncThunk(
    "orders/cancel",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await cancelOrder(payload);
            return response;
        } catch (error) {
            return rejectWithValue(error?.response?.data || "Error cancelling order");
        }
    }
);

export const submitPickupRequestThunk = createAsyncThunk(
    "orders/submitPickupRequest",
    async (payload, { rejectWithValue }) => {
        try {
            const res = await submitPickupRequest(payload);
            return res;
        } catch (error) {
            return rejectWithValue(error?.response?.data || "Error submiting pickup request");
        }
    }
);
